

import TopPanel from './container/index';

export default TopPanel;



// WEBPACK FOOTER //
// ./src/components/page/TopPanel/index.js